import { GiftIcon, MinusIcon, PlusIcon } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";
import { motion } from "framer-motion";

type Props = {
  purchased?: number;
  granted?: number;
  consumed?: number;
};

const items: Array<{
  key: keyof Props;
  label: string;
  icon: typeof PlusIcon;
  tone: string;
}> = [
  {
    key: "purchased",
    label: "Crédits achetés",
    icon: PlusIcon,
    tone: "bg-indigo-50 text-indigo-700",
  },
  {
    key: "granted",
    label: "Crédits offerts",
    icon: GiftIcon,
    tone: "bg-emerald-50 text-emerald-600",
  },
  {
    key: "consumed",
    label: "Crédits utilisés",
    icon: MinusIcon,
    tone: "bg-amber-50 text-amber-600",
  },
];

export const WalletStats = (values: Props) => (
  <section aria-label="Résumé des crédits" className="grid gap-3 sm:grid-cols-3">
    {items.map(({ key, label, icon: Icon, tone }, index) => (
      <motion.div
        key={key}
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.05 * index, duration: 0.25 }}
        className="flex items-center gap-3 rounded-xl border border-slate-200/80 bg-white px-4 py-3 shadow-[0_4px_18px_rgba(15,23,42,0.035)]"
      >
        <span className={cn("grid size-9 shrink-0 place-items-center rounded-lg", tone)}>
          <Icon size={17} weight="bold" />
        </span>
        <div className="min-w-0">
          <p className="text-[10px] font-medium text-slate-500">{label}</p>
          <p className="mt-0.5 truncate text-base font-bold tabular-nums text-[#071451]">
            {values[key] === undefined ? "…" : values[key]?.toLocaleString("fr-FR")}
          </p>
        </div>
      </motion.div>
    ))}
  </section>
);
